import type { UserRole, UserTier } from '@/types/next-auth';
export {
  PUBLIC_ROUTES,
  PROTECTED_ROUTES,
  getDefaultRoute,
  getRequiredRole,
} from '@/lib/route-contract';

/**
 * 역할 계층 (Backend UserRole enum과 동일)
 * USER < STAFF < ADMIN < SUPER_ADMIN
 */
const ROLE_RANK: Record<UserRole, number> = {
  USER: 0,
  STAFF: 1,
  ADMIN: 2,
  SUPER_ADMIN: 3,
};

/** current가 required 이상의 역할인지 확인 */
export function hasRole(current: UserRole | undefined, required: UserRole): boolean {
  return ROLE_RANK[current ?? 'USER'] >= ROLE_RANK[required];
}

/** access token (JWT)에서 최상위 역할 추출 */
export function resolveUserRole(accessToken: string | undefined): UserRole {
  if (!accessToken) return 'USER';
  try {
    const payload = JSON.parse(
      Buffer.from(accessToken.split('.')[1], 'base64').toString(),
    );
    const roles: string[] = payload.realm_access?.roles ?? [];
    for (let i = ROLE_HIERARCHY.length - 1; i >= 0; i--) {
      if (roles.some((r) => r.toUpperCase() === ROLE_HIERARCHY[i])) {
        return ROLE_HIERARCHY[i];
      }
    }
  } catch {
    // 디코딩 실패 시 기본값
  }
  return 'USER';
}

export const ROLE_HIERARCHY: UserRole[] = ['USER', 'STAFF', 'ADMIN', 'SUPER_ADMIN'];

// ---------------------------------------------------------------------------
// Tier (요금제/사용자 유형)
// ---------------------------------------------------------------------------

/** Keycloak realm role → UserTier 매핑 */
export function resolveUserTier(accessToken: string | undefined): UserTier {
  if (!accessToken) return 'GUEST';
  try {
    const payload = JSON.parse(
      Buffer.from(accessToken.split('.')[1], 'base64').toString(),
    );
    const roles: string[] = payload.realm_access?.roles ?? [];
    if (roles.some((r) => r.toUpperCase() === 'PRO_USER')) return 'PRO';
    if (roles.some((r) => r.toUpperCase() === 'FREE_USER')) return 'GUEST';
  } catch {
    // 디코딩 실패 시 기본값
  }
  return 'GUEST';
}

/** Tier → 한글 라벨 */
export const TIER_LABELS: Record<UserTier, string> = {
  GUEST: '학생',
  STANDARD: '회원',
  PRO: '교직원',
};
